<template>
  <div>
    <div id="navigation-bar">
      <div @click="routing('/rolesPage/SearchAppAdminApps/viewAppAdminApps')">
        <svg width="20" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.322 1.86938L9.73052 0.279377L1.06202 8.94488C0.922287 9.08373 0.811395 9.24884 0.735723 9.43072C0.660051 9.61259 0.621094 9.80764 0.621094 10.0046C0.621094 10.2016 0.660051 10.3967 0.735723 10.5785C0.811395 10.7604 0.922287 10.9255 1.06202 11.0644L9.73052 19.7344L11.3205 18.1444L3.18452 10.0069L11.322 1.86938Z" fill="black"/>
        </svg>
        <h3>
          New Application
        </h3>
      </div>
    </div>
    <section>
<!--       <div>
        <h3>New Application</h3>
        <div style="text-align: right;">{{ csvName }}</div>
      </div>
      <form id="createNewForm" @submit.prevent="submit">
        <table style="border-spacing: 5px;">
          <tr>
            <td>
              <label>Classification*:</label>
            </td>
            <td style="width: 80%;">
              <select name="classification" v-model="inputObject.classification">
                <option value="Assessment/Test">Assessment/Test</option>
                <option value="Questionnaire">Questionnaire</option>
              </select>
            </td>
          </tr>
          <tr>
            <td>
              <label>Title*:</label>
            </td>
            <td>
              <input name="title" type="text" v-model="inputObject.title" required>
            </td>
          </tr>
          <tr>
            <td>
              <label>Subtitle:</label>
            </td>
            <td>
              <input name="subtitle" type="text" v-model="inputObject.subtitle">
            </td>
          </tr>
          <tr>
            <td>
              <label>Custom Id*:</label>
            </td>
            <td>
              <input name="application_custom_id" type="text" v-model="inputObject.customID" required>
            </td>
          </tr>
          <tr>
            <td>
              <label>Info:</label >
            </td>
            <td>
              <input name="info" type="text" v-model="inputObject.info">
            </td>
          </tr>
          <tr>
            <td>
              <label>Area*:</label>
            </td>
            <td>
              <input name="area" type="text" v-model="inputObject.area" required>
            </td>
          </tr>
          <tr>
            <td>
              <label>Image/Logo:</label>
            </td>
            <td>
              <label class="custom-file-label-global">Upload
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-288-128 0c-17.7 0-32-14.3-32-32L224 0 64 0zM256 0l0 128 128 0L256 0zM216 408c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-102.1-31 31c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-31-31L216 408z"/></svg>
                <input name="image" id="imported-logo" @change="logoChange()" type="file" accept=".jpg, .jpeg, .png, .gif, .svg">
              </label>
              <div class="flexCenterCenter">
                <img id="preview-image">
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <label>For Sale:</label>
            </td>
            <td>
              <select name="on_sale" v-model="inputObject.onSale">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </td>
          </tr>
        </table>
        <div class="button-container">
          <button v-if="!loadingCreateNewApp" type="submit">Create Application</button>
          <button v-else>
            <b-spinner small></b-spinner>
            Create Application
          </button>
        </div>
      </form> -->
      <div id="inner-box">
        <div id="side-bar">
          <div :class="[stepIndex == 0 ? 'active-index' : null]">
            <span class="circle">1</span>
            Basic Info
          </div>
          <div :class="[stepIndex == 1 ? 'active-index' : null]">
            <span class="circle">2</span>
            Pricing
          </div>
          <div :class="[stepIndex == 2 ? 'active-index' : null]">
            <span class="circle">3</span>
            Additional Info
          </div>
        </div>
        <div>
          <div v-if="stepIndex == 0">
            <h2>Basic Info</h2>
            <div style="flex-grow: 1;">
              <hr />
              <label>Classification / Application Type<span style="color: #FF0000;">*</span></label>
              <select name="classification" v-model="inputObject.classification">
                <option value="Assessment/Test">Assessment/Test</option>
                <option value="Screening/Mini-Test">Screening/Mini-Test</option>
                <option value="Intervention/Training/Lesson">Intervention/Training/Lesson</option>
                <option value="Questionnaire">Questionnaire</option>
              </select>
              <label>Title<span style="color: #FF0000;">*</span></label>
              <input name="title" type="text" placeholder="Enter a descriptive title here" v-model="inputObject.title">
              <label>Subtitle</label>
              <input name="subtitle" type="text" placeholder="Enter a subtitle here" v-model="inputObject.subtitle">
              <label>Description</label>
              <textarea name="info" type="text" placeholder="Give some background on your application here" v-model="inputObject.info"></textarea>
              <div class="two-column">
                <label>Custom ID<span style="color: #FF0000;">*</span></label>
                <label>Area<span style="color: #FF0000;">*</span>:</label>
                <input name="info" type="text" placeholder="Unique code for your application" v-model="inputObject.customId">
                <input name="area" type="text" placeholder="Area of application" v-model="inputObject.area">
              </div>
              <label class="custom-file-label-global">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 16.0008C1.45 16.0008 0.979333 15.8051 0.588 15.4138C0.196666 15.0225 0.000666667 14.5515 0 14.0008V12.0008C0 11.7175 0.0960001 11.4801 0.288 11.2888C0.48 11.0975 0.717333 11.0015 1 11.0008C1.28267 11.0001 1.52033 11.0961 1.713 11.2888C1.90567 11.4815 2.00133 11.7188 2 12.0008V14.0008H14V12.0008C14 11.7175 14.096 11.4801 14.288 11.2888C14.48 11.0975 14.7173 11.0015 15 11.0008C15.2827 11.0001 15.5203 11.0961 15.713 11.2888C15.9057 11.4815 16.0013 11.7188 16 12.0008V14.0008C16 14.5508 15.8043 15.0218 15.413 15.4138C15.0217 15.8058 14.5507 16.0015 14 16.0008H2ZM7 3.8508L5.125 5.7258C4.925 5.9258 4.68767 6.0218 4.413 6.0138C4.13833 6.0058 3.90067 5.90146 3.7 5.7008C3.51667 5.5008 3.42067 5.26746 3.412 5.0008C3.40333 4.73413 3.49933 4.5008 3.7 4.3008L7.3 0.700796C7.4 0.600796 7.50833 0.53013 7.625 0.488796C7.74167 0.447463 7.86667 0.426463 8 0.425797C8.13333 0.42513 8.25833 0.44613 8.375 0.488796C8.49167 0.531463 8.6 0.60213 8.7 0.700796L12.3 4.3008C12.5 4.5008 12.596 4.73413 12.588 5.0008C12.58 5.26746 12.484 5.5008 12.3 5.7008C12.1 5.9008 11.8627 6.00513 11.588 6.0138C11.3133 6.02246 11.0757 5.92646 10.875 5.7258L9 3.8508V11.0008C9 11.2841 8.904 11.5218 8.712 11.7138C8.52 11.9058 8.28267 12.0015 8 12.0008C7.71733 12.0001 7.48 11.9041 7.288 11.7128C7.096 11.5215 7 11.2841 7 11.0008V3.8508Z" fill="black"/>
                </svg>
                Upload Image
                <input name="image" id="imported-logo" @change="logoChange()" type="file" accept=".jpg, .jpeg, .png, .gif, .svg">
              </label>
              <div class="flexCenterCenter">
                <img id="preview-image">
              </div>
              <hr />
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <button class="primary-button-sm-global nav-buttons" @click="stepIndex = 1">Next</button>
            </div>
          </div>
          <div v-else-if="stepIndex == 1">
            <h2>Pricing</h2>
            <div style="flex-grow: 1;">
              <hr />
              <label>Will this application be for sale?<span style="color: #FF0000;">*</span></label>
              <small style="display: block;">You can also change the setting later.</small>
              <select v-model="inputObject.onSale" style="margin-top: 10px;">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <div>
                <label>Price per Unit</label>
                <select v-model="inputObject.pricingUnit" style="width: fit-content; display: inline-block; margin-right: .5rem;">
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="JPY">JPY</option>
                  <option value="CNY">CNY</option>
                  <option value="RUB">RUB</option>
                </select>
                <input type="text" style="width: 200px;" placeholder="Enter Amount" v-model="inputObject.pricingNumber" /> / Unit
              </div>
              <div>
                <label>Monthly Subscription Pricing</label>
                <select v-model="inputObject.pricingUnit" style="width: fit-content; display: inline-block; margin-right: .5rem;">
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                  <option value="GBP">GBP</option>
                  <option value="JPY">JPY</option>
                  <option value="CNY">CNY</option>
                  <option value="RUB">RUB</option>
                </select>
                <input type="text" style="width: 200px;" placeholder="Enter Amount" v-model="inputObject.monthlySubscription" /> / month
              </div>
              <hr />
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <button style="margin-right: 5px;" class="secondary-gray-button-sm-global nav-buttons" @click="stepIndex = 0">Back</button>
              <button class="primary-button-sm-global nav-buttons" @click="stepIndex = 2">Next</button>
            </div>
          </div>
          <div v-else-if="stepIndex == 2">
            <h2>Additional Info</h2>
            <div style="flex-grow: 1;">
              <hr />
              <label>What is the age range for this application?</label>
              <input v-model="inputObject.ageRangeBegin" type="text" style="width: 60px;" placeholder="Age" /> 
                - 
              <input v-model="inputObject.ageRangeEnd" type="text" style="width: 60px;" placeholder="Age" /> Years
              <label>Estimated Duration of Application</label>
              <input v-model="inputObject.estimatedDurationHours" type="text" style="width: 60px;"/> hours
              <input v-model="inputObject.estimatedDurationMinutes" type="text" style="width: 60px;"/> minutes
              <hr />
            </div>
            <div style="display: flex; justify-content: flex-end;">
              <button style="margin-right: 5px;" class="secondary-gray-button-sm-global nav-buttons" @click="stepIndex = 1">Back</button>
              <button @click="submit" class="primary-button-sm-global nav-buttons">Create Application</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import instance from '../axios.js';
  import { v4 as uuidv4 } from 'uuid';
  //import Papa from 'papaparse';

  export default {
    data() {
      return {
        stepIndex: 0,
        csvName: null,
        loadingCreateNewApp: false,
        inputObject: {
          classification: 'Assessment/Test',
          title: '',
          subtitle: '',
          customID: '',
          info: '',
          area: '',
          logo: '',
          onSale: 'Yes',
          isFree: false,
          pricingUnit: 'USD',
          pricingNumber: '',
          largeQuantityPricingAmount: '',
          largeQuantityPricingDiscount: '',
          monthlySubscription: '',
          published: false,
          ageRangeBegin: 0,
          ageRangeEnd: 0,
          estimatedDurationHours: 0,
          estimatedDurationMinutes: 0,
        },
      }
    },
    methods: {
      routing(url) {
        this.$router.push(url);
      },
      downloadExampleCSV() {
        let reference = document.getElementById('import-csv-example');
        reference.click();
      },
      csvChange() {
        let csvRef = document.getElementById('imported-csv');
        if (csvRef.files.length > 0) {
          let file = csvRef.files[0];
          this.csvName = file.name;
        }
      },
      async logoChange() {
        const inputElement = document.getElementById("imported-logo");
        const previewImage = document.getElementById("preview-image");
        if (inputElement.files.length > 0) {
          const selectedFile = inputElement.files[0];
          this.inputObject.logo = selectedFile;
          previewImage.src = URL.createObjectURL(selectedFile);
          previewImage.style.display = "block";
          this.inputObject.logo = selectedFile;
        } 
        else {
          previewImage.src = "";
          previewImage.style.display = "none";
          this.inputObject.logo = '';
        }
      },
      submit() {
        this.loadingCreateNewApp = true;
/*         let csvRef = document.getElementById('imported-csv');
        if (csvRef.files.length > 0) {
          Papa.parse(csvRef.files[0], {
            transform: (value) => {
              if (value === "TRUE") return true;
              if (value === "FALSE") return false;
              return value;
            },
            complete: (result) => {
              // Remove empty rows
              const filteredData = result.data.filter(row => Object.values(row).some(value => value !== ''));
              const headers = filteredData[0];

              let allQuestions = [];
              let activity_id = uuidv4();
              for (let i = 1; i < filteredData.length; i++) {
                const rowData = filteredData[i];
            
                const obj = {};
                for (let j = 0; j < headers.length; j++) {
                  obj[headers[j]] = rowData[j];
                }
                allQuestions.push({
                  ...obj,
                  application_id: activity_id,
                  question_order: parseInt(obj.question_order, 10),
                  area_order: parseInt(obj.area_order, 10),
                  type_order: parseInt(obj.type_order, 10),
                  category_order: parseInt(obj.category_order, 10),
                  sub_category_order: parseInt(obj.sub_category_order, 10),
                  TTS_child_prompts: JSON.parse(obj.TTS_child_prompts),
                  question_id: uuidv4(),
                  transparent: obj.transparent.toUpperCase() == "TRUE" ? true : false
                });
              }
              const formData = new FormData();
              formData.append("application_id", activity_id);
              formData.append("application_custom_id", this.inputObject.customID);
              formData.append("owner_uuid", `${this.$store.getters.getCurrentUser}`);
              formData.append("classification", this.inputObject.classification);
              formData.append("title", this.inputObject.title);
              formData.append("subtitle", this.inputObject.subtitle);
              formData.append("info", this.inputObject.info);
              formData.append("image", this.inputObject.logo); 
              formData.append("on_sale", this.inputObject.onSale);
              formData.append("single_unit_pricing", `${this.inputObject.pricingNumber} ${this.inputObject.pricingUnit}`);
              formData.append("large_quantity_discount", `${this.inputObject.largeQuantityPricingAmount} Units for ${this.inputObject.largeQuantityPricingDiscount}% Discount`);
              formData.append("monthly_subscription_pricing", `${this.inputObject.largeQuantityPricingAmount} ${this.inputObject.monthlySubscription}`);
              formData.append("published", false);

              instance.post('/api/appAdmin', formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then(res => {
                console.log(res.data);
                instance.post('/api/question-admin/questions', allQuestions)
                .then(res => {
                  console.log(res.data);
                  this.$router.push(`/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/${activity_id}`);
                })
                .catch(err => {
                  console.error(err);
                });
              })
              .catch(err => {
                console.error(err);
              });
            },
            error: (error) => {
              console.error('CSV parsing error:', error.message);
            },
          });
        }
        else {
          let activity_id = uuidv4();
          const formData = new FormData();
          formData.append("application_id", activity_id);
          formData.append("application_custom_id", this.inputObject.customID);
          formData.append("owner_uuid", `${this.$store.getters.getCurrentUser}`);
          formData.append("classification", this.inputObject.classification);
          formData.append("title", this.inputObject.title);
          formData.append("subtitle", this.inputObject.subtitle);
          formData.append("info", this.inputObject.info);
          formData.append("image", this.inputObject.logo); 
          formData.append("on_sale", this.inputObject.onSale);
          formData.append("single_unit_pricing", `${this.inputObject.pricingNumber} ${this.inputObject.pricingUnit}`);
          formData.append("large_quantity_discount", `${this.inputObject.largeQuantityPricingAmount} Units for ${this.inputObject.largeQuantityPricingDiscount}% Discount`);
          formData.append("monthly_subscription_pricing", `${this.inputObject.largeQuantityPricingAmount} ${this.inputObject.monthlySubscription}`);
          formData.append("published", false);
          instance.post('/api/appAdmin', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            console.log(res.data);
            this.$router.push(`/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/${activity_id}`);
          })
          .catch(err => {
            console.error(err);
          });
        } */
        function toInterval(hours, minutes) {
          const hh = String(hours).padStart(2, '0');
          const mm = String(minutes).padStart(2, '0');
          const ss = '00'; 
          return `${hh}:${mm}:${ss}`;
        }

        if (this.inputObject.title == '') {
          alert('Title Missing');
          return;
        }
        if (this.inputObject.customId == '') {
          alert('Custom ID Missing');
          return;
        }
        if (this.inputObject.area == '') {
          alert('Area Missing');
          return;
        }
        if (this.inputObject.title == '') {
          alert('Title Missing');
          return;
        }

        let activity_id = uuidv4();
        const formData = new FormData();
        formData.append("application_id", activity_id);
        formData.append("owner_uuid", `${this.$store.getters.getCurrentUser}`);
        formData.append("application_custom_id", this.inputObject.customId);
        formData.append("classification", this.inputObject.classification);
        formData.append("title", this.inputObject.title);
        formData.append("subtitle", this.inputObject.subtitle);
        formData.append("info", this.inputObject.info);
        formData.append("area", this.inputObject.area);
        formData.append("image", this.inputObject.logo);
        formData.append("is_free", this.inputObject.isFree);
        formData.append("on_sale", this.inputObject.onSale == 'Yes' ? true: false);
        formData.append("published", this.inputObject.published);
        formData.append("currency_code", this.inputObject.pricingUnit);
        formData.append("single_unit_pricing", this.inputObject.pricingNumber);
        formData.append("monthly_subscription_pricing", this.inputObject.monthlySubscription);
        formData.append("age_range", `[${this.inputObject.ageRangeBegin},${this.inputObject.ageRangeEnd}]`);
        formData.append("estimated_duration", toInterval(this.inputObject.estimatedDurationHours, this.inputObject.estimatedDurationMinutes));

        this.loadingCreateNewApp = false;
        instance.post('/api/appAdmin', formData)
        .then(res => {
          console.log(res.data);
          this.loadingCreateNewApp = false;
          this.$router.push(`/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard/${activity_id}`);
        })
        .catch(err => {
          console.error(err);
          this.loadingCreateNewApp = false;
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';
  
  .flexCenterCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .flexBtwCenter {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #navigation-bar {
    height: globalSharedVariables.$navbar-height;
    border-bottom: 1px #CBCBCB solid;
    display: flex;
    align-items: center;

    > div {
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    h3 {
      margin: 0 1rem;
    }

    svg {
      margin-left: 2rem;
    }
  }

  section {
    display: flex;
    justify-content: center;
    padding: 1rem;
    min-height: calc(100vh - #{globalSharedVariables.$navbar-height});

    #inner-box {
      display: grid;
      grid-template-columns: 240px 630px;
      column-gap: 1rem;

      #side-bar {
        font-weight: 700;
        color: globalSharedVariables.$grey-400;

        > div {
          padding: .5rem;

          .circle {
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            border: solid globalSharedVariables.$grey-200 1px;
            color: globalSharedVariables.$grey-600;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            font-weight: 400;
            margin-right: 10px;
            background-color: white;
            font-weight: 700;
          }

          &.active-index {
            background-color: globalSharedVariables.$brand-50;
            color: globalSharedVariables.$brand-700;

            .circle {
              color: globalSharedVariables.$brand-700;
              border: solid globalSharedVariables.$brand-700 1px;
            }
          }
        }
      }

      > div:nth-child(2) {
        height: 100%;

        > div {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 100%;
        }

        small {
          color: #7E7E7E;
        }

        label {
          display: block;
          margin-top: 2rem;
          margin-bottom: 0;
          font-weight: 700;
        }

        input[type="text"], textarea {
          width: 100%;
        }

        input[type="text"], textarea, select {
          padding: .5rem;
        }

        input[type="text"], select {
          height: 42px;
        }

        .custom-file-label-global {
          width: fit-content;
        }

        .two-column {
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 2rem;
        }

        .nav-buttons {
          font-weight: 700;
        }
      }
    }
  }

  table {
    td {
      padding: 5px;
      font-size: 1rem;
      font-weight: 700;
    }

    input {
      background-color: white;
      border-radius: 50rem;
      padding-left: .5rem;
      padding-right: .5rem;
      width: 100%;
      font-size: 1rem;
      font-weight: 400;
    }

    tr td:first-child {
      font-weight: 700;
      display: flex;
      align-items: center;
    }

    label {
      display: inline-block;
      margin-bottom: 0;
    }

    .table-section-divider {
      text-align: center;
      border-top: dashed black 1px;
      border-top-width: 2px;
    }
  }

  .input-file-label {
    width: fit-content;
    font-weight: 400;
    cursor: pointer;

    border-radius: 50rem;
    border: solid 1px globalSharedVariables.$brand-400;
    box-shadow: 0 0 5px 0 grey;
    padding: 0 10px;
    font-size: 1rem;
    outline: none; 

    &:hover {
      background-color: globalSharedVariables.$brand-400;
    }
  }

  .input-file-label input[type="file"] {
    display: none;
  }

  #preview-image {
    display: none;
    margin-top: .5rem;
    margin-bottom: .5rem;
    width: 100%;
  }

</style>